export interface Tier {
    tier_number: number;
    min_quantity: number;
    max_quantity?: number | null;
    discount_percentage?: number | null;
    free_units?: number | null;
}

export interface PricingDisplayData {
    basePrice: number;
    discountPercentage?: number | null;
    freeUnits?: number | null;
    customPrice: number;
    tiers?: Tier[];
}

export const usePricingDisplay = (data: PricingDisplayData) => {
    const { basePrice, discountPercentage, freeUnits, customPrice, tiers = [] } = data;

    // Determine current mode based on which field is non-null
    const currentMode = freeUnits !== null && freeUnits !== undefined ? 'free_units'
        : discountPercentage !== null && discountPercentage !== undefined ? 'percentage'
            : 'fixed';

    // Filter tiers by current mode
    const relevantTiers = tiers.filter(tier => {
        if (currentMode === 'percentage') {
            return tier.discount_percentage !== undefined && tier.discount_percentage !== null;
        } else if (currentMode === 'free_units') {
            return tier.free_units !== undefined && tier.free_units !== null;
        }
        return false;
    });

    // Mode display - only show the non-null mode
    const modeDisplay = currentMode === 'free_units' ? 'UG'
        : currentMode === 'percentage' ? '%'
            : '-';

    // Reduction display string
    const reductionValue = (() => {
        if (freeUnits && freeUnits > 0) {
            return `${freeUnits} UG`;
        }
        if (discountPercentage && discountPercentage > 0) {
            return `${discountPercentage.toFixed(2)}%`;
        }
        const reduction = Math.max(0, basePrice - customPrice);
        return reduction > 0.001 ? `${reduction.toFixed(2)} €` : '-';
    })();

    // Check if should show "Voir paliers"
    const hasTiers = relevantTiers.length > 0;

    // Price value
    const priceValue = customPrice.toFixed(2);

    return {
        currentMode,
        modeDisplay,
        reductionValue,
        priceValue,
        hasTiers,
        relevantTiers,
        tierCount: relevantTiers.length
    };
};
